var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolumeOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4212_9405",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4212_9405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2275 18.4491L13.7147 15.9363C13.4262 16.1211 13.1223 16.2813 12.8028 16.417C12.4834 16.5527 12.1527 16.6665 11.8109 16.7584V15.4667C11.9893 15.4026 12.1629 15.3372 12.3317 15.2704C12.5005 15.2036 12.6602 15.1243 12.8108 15.0324L9.82366 12.0452V15.6574L6.24997 12.0837H3.15706V7.91707H5.69549L1.66345 3.88502L2.54162 3.00684L17.1057 17.5709L16.2275 18.4491ZM15.8204 13.9443L14.9246 13.0485C15.2141 12.5966 15.4353 12.1118 15.5881 11.5941C15.7409 11.0765 15.8173 10.5383 15.8173 9.97955C15.8173 8.71673 15.45 7.58211 14.7155 6.57571C13.981 5.56929 13.0128 4.87485 11.8109 4.49238V3.20073C13.3675 3.61633 14.6327 4.44913 15.6065 5.69913C16.5803 6.94911 17.0672 8.37592 17.0672 9.97955C17.0672 10.7103 16.9585 11.412 16.7411 12.0845C16.5237 12.757 16.2168 13.377 15.8204 13.9443ZM13.2692 11.393L11.8109 9.93471V6.91386C12.3728 7.21941 12.8071 7.6497 13.1137 8.20471C13.4203 8.75974 13.5737 9.3583 13.5737 10.0004C13.5737 10.2461 13.5483 10.4857 13.4975 10.7191C13.4468 10.9526 13.3707 11.1772 13.2692 11.393ZM9.82366 7.94752L8.0256 6.14144L9.82366 4.3434V7.94752ZM8.57368 12.6254V10.7953L6.94547 9.16705H4.40701V10.8337H6.78201L8.57368 12.6254Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/volume_off.9282026acc4130e0bb0243595b9a7cfc.svg";
export { ForwardRef as ReactComponent };